{
  "titleText": {
    "title": "<h1>Discover How to Make Your GO Consumption Profitable</h1>",
    "description": "Book a free consultation with our experts to receive a tailored analysis on how much you can save with DEC (on electricity consumption).",
    "tag": "DISCOVER ALL THE BENEFITS"
  },
  "inquiryTypes": {
    "P": "Energy procurement",
    "S": "Sustainability",
    "I": "Independent producer",
    "U": "Utility",
    "O": "Other"
  },
  "select": "Select",
  "form": {
    "submit": "Submit",
    "success": "Thanks, your request was sent. We'll be in touch shortly.",
    "error": "Something went wrong while sending your request. Please try again.",
    "fields": {
      "name": {
        "label": "Full name",
        "error": "Full name is required"
      },
      "company_name": {
        "label": "Company",
        "error": "Company name is required"
      },
      "email": {
        "label": "Work email",
        "error": "Enter a valid email"
      },
      "additional_info": {
        "label": "Additional notes"
      },
      "number": {
        "label": "Phone",
        "required": "Phone number is required",
        "invalid": "Enter a valid phone number"
      },
      "user_type": {
        "label": "Inquiry type",
        "error": "Select an inquiry type"
      }
    }
  }
}
